import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../../../App'
import API from '../../../../services/API'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import DoorSliding from '@mui/icons-material/DoorSliding'

const ReturnToStores = ({ drugBag, setView }) => {
  const [moveBagLocation, setMoveBagLocation] = useState('')
  const [moveBagOptions, setMoveBagOptions] = useState([])
  const { setToast } = useContext(GlobalContext)

  useEffect(() => {
    API.get('/newlocationoptions?storesOnly=true')
      .then((res) => {
        setMoveBagOptions(res.data)
        if (res.data.length === 1) {
          setMoveBagLocation(res.data[0]._id)
        }
      })
      .catch(() => {
        setToast({
          message: 'Unable to load stores. Please try again later.',
          severity: 'error',
        })
      })
  }, [])

  const handleConfirm = () => {
    API.post('/medsmx/newlocation', {
      id: drugBag._id,
      store: moveBagLocation,
      deleteVehicle: true,
      deleteEmployee: true,
    })
      .then((res) => {
        if (res.status === 200) {
          setView('home')
          setToast({ message: 'Bag returned to stores' })
        }
      })
      .catch(() =>
        setToast({
          message: 'Unable to return bag. Please try again later.',
          severity: 'error',
        }),
      )
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        backgroundColor: '#fff',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 2,
            display: 'grid',
            placeItems: 'center',
            color: '#242F40',
            backgroundColor: '#242F4014',
          }}
        >
          <DoorSliding />
        </Box>

        <Stack spacing={0.5} textAlign="center">
          <Typography variant="h6" fontWeight={950}>
            Return {drugBag.name} to stores
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Choose the store receiving this medicine bag.
          </Typography>
        </Stack>

        <FormControl fullWidth size="small">
          <InputLabel id="return-store-label">Store</InputLabel>
          <Select
            labelId="return-store-label"
            id="newLocation"
            label="Store"
            value={moveBagLocation ?? ''}
            onChange={(event) => setMoveBagLocation(event.target.value)}
          >
            {moveBagOptions.map((option) => (
              <MenuItem key={option._id} value={option._id}>
                {option.callSign ?? option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} width="100%">
          <Button
            onClick={handleConfirm}
            disabled={!moveBagLocation}
            variant="contained"
            fullWidth
            sx={{
              borderRadius: 1.5,
              textTransform: 'none',
              fontWeight: 900,
              backgroundColor: '#1E7F88',
            }}
          >
            Return to store
          </Button>
          <Button
            onClick={() => setView('home')}
            variant="outlined"
            fullWidth
            sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 850 }}
          >
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default ReturnToStores
